import React from 'react';
import { FaRobot } from 'react-icons/fa';
import { IconBaseProps } from 'react-icons';
import './AssistantButton.css';

const RobotIcon = FaRobot as React.FunctionComponent<IconBaseProps>;

interface AssistantButtonProps {
  onClick: () => void;
}

const AssistantButton: React.FC<AssistantButtonProps> = ({ onClick }) => {
  return (
    <button className="assistant-button" onClick={onClick} aria-label="打开AI助手">
      <RobotIcon />
    </button>
  );
};

export default AssistantButton;
